import React from 'react';

const CodeIcon = ({ size="48", color = "#56B0BB" }: { size?: string | number; color?: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_77_12068)">
        <path
          d="M27.56 8L20.44 40M36 16L44 24L36 32M12 32L4 24L12 16"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_77_12068">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CodeIcon;
